import script from "./OurBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./OurBoard.vue?vue&type=script&setup=true&lang=js"

import "./OurBoard.vue?vue&type=style&index=0&id=54235800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54235800"]])

export default __exports__